import {
    postFuelLoading,
    postFuelRequest,
    postFuelSuccess,
    postFuelReject,
    postFuelReset
} from "../../actions/fuel/post";

export const postFuel = (formData) => async (dispatch, getState) => {
    dispatch(postFuelLoading());
    try {
        const { data } = await postFuelRequest(formData, getState);
        dispatch(postFuelSuccess(data))
    } catch (error) {
        dispatch(postFuelReject(error))
    } finally {
        setTimeout(() => { dispatch(postFuelReset()) }, 3000);
    }
    return Promise.resolve();
};